const findTooltipContent = (code) => {
    let tooltipContent = '';
    switch (code) {
        case 'EFX_LEGAL_NAME':
            tooltipContent = 'Official name of the person or entity owning your business. This name appears on the formation documentation for your company. As the business owner, you may change your "Legal Business Name" at anytime.'
            break;
        case 'EFX_LEGSUBNUMALL':
            tooltipContent = 'Name of the parent or holding company that has a controlling stake in your business.'
            break;
        case 'ID_TYPE':
            tooltipContent = 'The Tax ID Type that is typically used to identify your business and pay taxes.'
            break;
        case 'EIN':
            tooltipContent = "Nine-digit identifier for your business's EIN (Employer Identification Number), ITIN (Individual Tax ID Number) or SSN (Social Security Number)."
            break;
        case 'EFX_NAME':
            tooltipContent = 'Regulation and filing requirements for a DBA varies by state. In some states, more than one company can have the same DBA. Trademark your business name to be the sole user of it.'
            break;
        case 'EFX_EMAIL':
            tooltipContent = "Using your company's name for your email domain, such as yourname@yourcompany.com, helps establish your identity and credibility when communicating to customers or partners.  "
            break;
        case 'EFX_WEB':
            tooltipContent = "Serves as a source of information and direct link to the services/products your business offers. SEO (Search Engine Optimization) can be used to improve the quantity and quality of traffic coming to your businesses' website."
            break;
        case 'EFX_PHONE':
            tooltipContent = 'A direct line for customers to connect with your company. It can be further built out with automated messages that provide information and guidance to customers inquiring about certain aspects of your business.'
            break;
        case 'EFX_FAXPHONE':
            tooltipContent = 'Used to send and receive documents, rather than calls. The number can be localized to specific regions.'
            break;
        case 'EFX_ADDRESS':
            tooltipContent = 'The location where you want to direct customers or partners. Typically a physical street address or mailing address is used.'
            break;
        case 'EFX_CITY':
            tooltipContent = 'The city that this specific business resides in. This could include any structure or department that conducts business on behalf of your company.'
            break;
        case 'EFX_STATE':
            tooltipContent = 'This is typically where your business is registered. However, business owners are not required to live in the state their business is registered in.'
            break;
        case 'EFX_ZIPCODE':
            tooltipContent = 'The most precise geographical location data for a business. The standard notation used is five digits.'
            break;
        case 'EFX_CTRYISOCD':
            tooltipContent = 'This is typically where your business is registered. However, business owners are not required to live in the country their business is registered in.'
            break;
        case 'EFX_CONTCT':
            tooltipContent = "An employee that is responsible for overseeing an aspect of your business. This could be management or an employee designated with the responsiblity of overseeing your businesses' Markaaz Dashboard account."
            break;
        case 'EFX_TITLECD':
            tooltipContent = 'The position of the employee that is responsible for overseeing an aspect of your business or the Markaaz Dashboard account.'
            break;
        case 'PRIMARY_PHONE':
            tooltipContent = 'Guide to Updating Public Information automatically'
            break;
        case 'PRIMARY_EMAIL':
            tooltipContent = 'Guide to Updating Public Information automatically'
            break;
        case 'EFX_PRIMNAICSDESC':
            tooltipContent = "The sector that your businesses' primary activities is classified. Your NAICS (North American Indsutry Classification System) code is used by federal entities to classify businesses."
            break;
        case 'EFX_YREST':
            tooltipContent = 'The date of incorporation for your business. More specifically, the date your Secretary of State approved and filed your business registration documentation.'
            break;
        case 'DESCRIPTION':
            tooltipContent = 'A Company Description is a summary of your business. It is used to describe the mission statement, key aspects and features of your business.'
            break;
        case 'EFX_CORPEMPCNT':
            tooltipContent = 'An actual or estimated number of employees for your entire corporation, including all locations globally.'
            break;
        case 'EFX_CORPAMOUNT':
            tooltipContent = 'An actual or estimated total amount of your corporations revenue, sales or assets.'
            break;
        case 'EFX_FOREIGN':
            tooltipContent = 'Indicator if the location of your business is legally owned in or outside the United States.'
            break;
        case 'EFX_PUBLIC':
            tooltipContent = 'Indicator if your business is publicly traded on the United States stock market.'
            break;
        case 'EFX_VET':
            tooltipContent = 'Your business is at least 51% owned and controlled by one or more U.S. citizens who are veterans of the United States Armed Forces.'
            break;
        case 'EFX_WBE':
            tooltipContent = 'Your business is at least 51% owned and controlled by one or more United States citizens who identify as female.'
            break;
        case 'EFX_MBE':
            tooltipContent = 'Your business is at least 51% owned and controlled by one or more United States citizens who belong to an ethnic minority group.'
            break;
        case 'EFX_GOV':
            tooltipContent = 'Your business is closely affiliated or controlled by a United States governing body.'
            break;
        case 'EFX_FGOV':
            tooltipContent = 'A Federal Government Entity is part of the United States government or any bureau/department of the federal government.'
            break;
        case 'EFX_NONPROFIT':
            tooltipContent = 'Indicates that your business is a non-profit entity.'
            break;
        case 'EFX_EDU':
            tooltipContent = 'Indicates that your business is a place where people can get an education, such as trade school, junior college or university, and is directly operated or accredited by a governing body.'
            break;
        case 'BIZ_LOGO':
            tooltipContent = 'A visual reference for people to recognize your business. Logos are an important tool to establish a brand identity and make a strong and lasting impression that seperates your business from competitors.'
            break;

        default: tooltipContent = 'Guide to Updating Public Information automatically';

    }
    return tooltipContent
}

export default findTooltipContent;
